import * as generalApi from '../../../general/api';

export function getCoverage(params) {
  return generalApi.getOsCoverage({ cloudType: 'vdc', ...params });
}

export function getCoverageCSV(params) {
  return generalApi.getOsCoverageCSV({ cloudType: 'vdc', ...params });
}
